const INITIAL_MESSAGE_KEY_PREFIX = 'initial_message_'

function buildStorageKey(conversationUuid: string): string {
  return `${INITIAL_MESSAGE_KEY_PREFIX}${conversationUuid}`
}

export function storePendingInitialMessage(conversationUuid: string, message: string): void {
  if (!conversationUuid) {
    return
  }

  const key = buildStorageKey(conversationUuid)
  const trimmedMessage = message.trim()
  if (!trimmedMessage) {
    sessionStorage.removeItem(key)
    return
  }

  sessionStorage.setItem(key, trimmedMessage)
}

export function consumePendingInitialMessage(conversationUuid: string): string | null {
  if (!conversationUuid) {
    return null
  }

  const key = buildStorageKey(conversationUuid)
  try {
    const message = sessionStorage.getItem(key)
    if (!message) {
      return null
    }
    sessionStorage.removeItem(key)
    return message
  } catch {
    return null
  }
}
